import { render, staticRenderFns } from "./reactivos-ordenamiento.vue?vue&type=template&id=2bb9505d&scoped=true&"
import script from "./reactivos-ordenamiento.vue?vue&type=script&lang=js&"
export * from "./reactivos-ordenamiento.vue?vue&type=script&lang=js&"
import style0 from "./reactivos-ordenamiento.vue?vue&type=style&index=0&id=2bb9505d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb9505d",
  null
  
)

export default component.exports